import React from 'react';
import LoadingIcon from '../loading_icon/loading_icon';
import './loading_fullscreen.scss';

function LoadingFullscreen(props) {
  return (
    <div
      className={`loading-fullscreen${props.visible ? '' : '--hidden'}`}
      key="loading-fullscreen"
    >

      <div className="loading-fullscreen__wrapper">

        <div className="loading-fullscreen__icon-wrapper">

          <LoadingIcon className="loading-fullscreen__icon" />

        </div>

      </div>         

    </div>
  );
}

export default LoadingFullscreen;
